import script from "./ShoppingCartPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingCartPanel.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingCartPanel.vue?vue&type=style&index=0&id=28b326a7&scoped=true&lang=css"
import "./ShoppingCartPanel.vue?vue&type=style&index=1&id=28b326a7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b326a7"]])

export default __exports__